export default (batchLoadFileContent) => {
  let csvContent = ''
  for (let m of batchLoadFileContent) {
    let row = m.join(',')
    csvContent += row + "\r\n"
  }
  return csvContent
}
